import React from "react";
import { BriefcaseBusiness, CalendarDays, RefreshCcw, Upload } from "lucide-react";

export default function PlannerActionsBar({
  onUploadLetterClick,
  onOpenPracticeManagerImport,
  onExportCalendar,
  onReset,
}) {
  return (
    <div className="aid-planner-no-print flex flex-wrap gap-2">
      <button
        onClick={onUploadLetterClick}
        className="px-4 py-2 rounded-lg bg-purple-600 text-white text-sm font-semibold hover:bg-purple-700 shadow-sm transition-all inline-flex items-center gap-2"
      >
        <Upload className="w-4 h-4" />
        Upload from inbox
      </button>
      <button
        onClick={onOpenPracticeManagerImport}
        className="px-4 py-2 rounded-lg border border-slate-200 text-sm font-medium text-slate-700 hover:border-purple-300 hover:text-purple-700 inline-flex items-center gap-2"
      >
        <BriefcaseBusiness className="w-4 h-4" />
        Import from practice manager
      </button>
      <button
        onClick={onExportCalendar}
        className="px-4 py-2 rounded-lg border border-slate-200 text-sm font-medium text-slate-700 hover:border-purple-300 hover:text-purple-700 inline-flex items-center gap-2"
      >
        <CalendarDays className="w-4 h-4" />
        Export ICS
      </button>
      <button
        onClick={onReset}
        className="px-4 py-2 rounded-lg border border-slate-200 text-sm font-medium text-slate-700 hover:border-rose-300 hover:text-rose-700 inline-flex items-center gap-2"
      >
        <RefreshCcw className="w-4 h-4" />
        Reset
      </button>
    </div>
  );
}
